import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import Loader from "feature-module/loader/loader";
import { useTableSearch } from "core/Operations/useTableSearch";
import {
  Edit,
  PlusCircle,
  Users,
  Filter,
} from "feather-icons-react/build/IconComponents";
import Error404 from "MainPages/ErrorPages/error404";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useGetEmpAttendanceByDateQuery } from "AppQuries/attendance/get-attendance";
import Attendance from "Components/Modal/attendance";
import { addSingleAttendaceValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import { useAddAttendanceMutation } from "AppQuries/attendance/add-attendance";
import ImageWithBasePath from "core/img/imagewithbasebath";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { Download } from "react-feather";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
const AttendanceManagement = () => {
  const userData = useSelector(loggedInUser);
  const [attendanceFilterDate, setAttendanceFilterDate] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: fetchAttendance,
  } = useGetEmpAttendanceByDateQuery(
    {
      companyCode: userData.companyCode,
      locationCode: userData?.selectedLocationCode,
      filterDate: attendanceFilterDate || format(new Date(), "yyyy-MM-dd"),
    },
    { fetchOnWindowsFocus: false }
  );
  const methods = useForm({
    resolver: yupResolver(addSingleAttendaceValidationSchema),
    defaultValues: {
      companyCode: userData?.companyCode,
      attendanceDate: format(new Date(), "yyyy-MM-dd"),
      attendanceValue: 1,
      inTime: userData?.companyOpenTime,
      outTime: userData?.companyCloseTime,
    },
  });

  const { mutate: addAttendance } = useAddAttendanceMutation();

  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const attendanceData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const handleAddClick = () => {
    setSelectedDesignation(null);
    methods.reset({
      companyCode: userData.companyCode,
      description: "",
      isActive: 1,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (designation) => {
    setSelectedDesignation(designation);
    methods.reset({
      companyCode: designation.companyCode,
      description: designation.description,
      isActive: designation.isActive ? 1 : 0,
      createUser: designation.createUser,
      createDate: designation.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    
    const attendanceData = {
      companyCode: 1,
      attendanceDate: payload.attendanceDate,
      attendance: [
        {
          employeeCode: Number(payload.employeeCode),
          attendanceValue: payload.attendanceValue,
          inTime: payload.inTime,
          outTime: payload.outTime,
          createUser: userData.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData.userName,
          modifyDate: getCurrentFormattedDate(),
          scheduleId: payload.scheduleId,
        },
      ],
    };


    addAttendance(attendanceData, {
      onSuccess: (data) => {
        
        if (data[0].response === true) {
          setMessage("Attendance Saved Successfully.");
          setShowSuccessToast(true);
          setSelectedDesignation(null);
          setShow(false);
          fetchAttendance();
        } else {
          setMessage(data[0].errorMessage);
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const columns = [
    {
      title: "Full Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Emp Code",
      dataIndex: "employeeCode",
      sorter: (a, b) => a.employeeCode.length - b.employeeCode.length,
    },
    {
      title: "Date",
      dataIndex: "attendanceDate",
      render: (text, record) => (
        <>
          <span>{format(new Date(text), "dd-MM-yyyy")}</span>
        </>
      ),
    },
    {
      title: "Attendance",
      dataIndex: "attendanceValue",
      render: (text, record) => (
        <>
          {text === 0 && <div>Absent</div>}
          {text === 0.5 && <div>Half Day</div>}
          {text === 1 && <div>Present</div>}
        </>
      ),
    },
    {
      title: "Clock In",
      dataIndex: "inTime",
      render: (text, record) => (
        <>
          <span>{text.split(".")[0]}</span>
        </>
      ),
      sorter: (a, b) => a.inTime.length - b.inTime.length,
    },
    {
      title: "Clock Out",
      dataIndex: "outTime",
      render: (text, record) => (
        <>
          <span>{text.split(".")[0]}</span>
        </>
      ),
      sorter: (a, b) => a.outTime.length - b.outTime.length,
    },
    {
      title: "Total Hours",
      dataIndex: "totalHours",
      sorter: (a, b) => a.totalHours.length - b.totalHours.length,
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    attendanceData,
    searchColumns
  );

  if (isLoading || isFetching) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Attendance Management</h4>
                <h6>Manage your employees attendance</h6>
              </div>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Add Attendance</Tooltip>}
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add Attendance
                </Link>
              </OverlayTrigger>
            </div>

            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Bulk Attendance</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.attendance}${all_routes.attendance_day}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Day Attendance
                </Link>
              </OverlayTrigger>
            </div>

            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Monthly Attendance</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.attendance}${all_routes.attendance_month}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Monthly Attendance
                </Link>
              </OverlayTrigger>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Import Attendance</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.attendance}${all_routes.attendance_import}`}
                  className="btn btn-added btn-secondary"
                >
                  <Download className="me-2" />
                  Import Attendance
                </Link>
              </OverlayTrigger>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="col-lg-3 col-sm-6 col-12 mb-3">
                          <label>
                            Attendance Date<span className="asterisk">*</span>
                          </label>
                          {/* <Controller
                            name="attendanceFilterDate"
                            control={control}
                            defaultValue=""
                            render={({ field }) => ( */}
                          <DatePicker
                            // {...field}
                            className={`form-control`}
                            placeholder="Attendace Filter date"
                            value={
                              attendanceFilterDate
                                ? dayjs(attendanceFilterDate, "YYYY-MM-DD")
                                : ""
                            }
                            format="DD-MM-YYYY"
                            onChange={(date) => {
                              setAttendanceFilterDate(
                                date ? dayjs(date).format("YYYY-MM-DD") : ""
                              );
                            }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                          {/* )}
                          /> */}
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                          <div className="input-blocks">
                            <Link
                              className="btn btn-filters ms-auto"
                              onClick={fetchAttendance}
                            >
                              <i
                                data-feather="search"
                                className="feather-search"
                              />
                              Filter
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <Attendance
          mode={selectedDesignation ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};

export default AttendanceManagement;
